import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import Container from "./components/Container/Container";
import GlobalContext from "./context/Global";
import StoriesContext from "./context/Stories";
import { renderers as defaultRenderers } from "./components/index";
import { generateStories } from "./utils/renderers";
var Story = function(props) {
    var stories = props.stories, renderers = props.renderers;
    var vfRenderers = renderers ? renderers.concat(defaultRenderers) : defaultRenderers;
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    var context = _object_spread({}, props);
    var ref = useState({
        stories: generateStories(stories || [], vfRenderers)
    }), vfStories = ref[0], setVfStories = ref[1];
    useEffect(function() {
        setVfStories({
            stories: generateStories(stories || [], vfRenderers)
        });
    }, [
        stories,
        renderers
    ]);
    return /*#__PURE__*/ _jsx(GlobalContext.Provider, {
        value: context,
        children: /*#__PURE__*/ _jsx(StoriesContext.Provider, {
            value: vfStories,
            children: /*#__PURE__*/ _jsx(Container, {})
        })
    });
};
Story.defaultProps = {
    width: 405,
    height: 720,
    defaultInterval: 4000
};
export default Story;
